<div class="container-fluid vh-100 w-100">
  <div class="row p-2 justify-content-center">
    <div class="form-body col-offset-lg-2 col-lg-5 col-offset-sm-2 col-sm-8">
      <div class="card border-1">
        <div class=" text-center">
          <h3>
            {{"EVENTO" | translate}} {{frmCadastro.id}}
          </h3>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="{{frmField.columns ? frmField.columns : 'col-md-12'}}" *ngFor="let frmField of frmFieldList">
              <div class="mb-3">
                <label for="{{frmField.field}}" class="form-label">{{frmField.label | translate}}
                  <span class="text-danger" *ngIf="frmField.required">*</span>
                </label>
                <ng-container *ngIf="frmField.type === 'long-text' ">
                  <textarea type="text" class="form-control" id="description" rows="10" disabled="disabled" [innerHTML]="frmCadastro[frmField.field]"></textarea>
                </ng-container>
                <ng-container *ngIf="frmField.type !== 'long-text' && frmField.type !== 'select'">
                  <input [type]="frmField.type" class="form-control" disabled="disabled" [id]="frmField.field" [value]="frmCadastro[frmField.field]">
                </ng-container>
                <ng-container *ngIf="frmField.type === 'select'">
                  <select class="form-control" disabled>
                    <option value="">Selecione</option>
                    <option *ngFor="let opt of frmField.options" [value]="opt.value" [selected]="opt.value == frmCadastro[frmField.field]">
                      {{ opt.label }}
                    </option>
                  </select>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer text-center">
          <div class="row">
            <div class="col-md-12">
              <button type="button" [routerLink]="['/', 'index']" routerLinkActive="router-link-active"  class="btn btn-primary">{{"VOLTAR" | translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
